module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 13
// module chunks = 0